<template>
	<v-card class="card">
		<v-card-text>
			<table>
				<tr>
					<td class="red icon"></td>
					<td style="width: 60px;">Red</td>
					<td class="traffic-light-description">{{ redDescription }}</td>
				</tr>
				<tr>
					<td class="amber icon"></td>
					<td>Amber</td>
					<td class="traffic-light-description">{{ amberDescription }}</td>
				</tr>
				<tr>
					<td class="green icon"></td>
					<td>Green</td>
					<td class="traffic-light-description">{{ greenDescription }}</td>
				</tr>
				<tr>
					<td class="na icon"></td>
					<td>N/A</td>
					<td class="traffic-light-description">{{ naDescription }}</td>
				</tr>
			</table>
		</v-card-text>
	</v-card>
</template>

<script>
	import trafficLightsMixin from '@/mixins/trafficLightsMixin';

	export default {
		mixins: [trafficLightsMixin]
	};
</script>

<style scoped>
	.card {
		text-align: left;
		margin-top: 20px;
	}
	.icon {
		display: inline-block;
		width: 20px;
		height: 20px;
		border-radius: 10px;
		margin-right: 10px;
	}
	.icon td {
		height: 20px;
	}
	.icon td .item-btn {
		width: 20px !important;
		height: 20px! important;
	}
	.traffic-light-description {
		font-style: italic;
	}
	.icon.na {
		background-color: #e8eaf6;
		border-color: #e8eaf6;
	}
</style>
